import React from 'react';
export function Divider({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center justify-center w-full py-8 opacity-60 ${className}`} data-id="element-80">
      <div className="w-16 md:w-24 h-[1px] bg-sage" data-id="element-81"></div>
      <div className="mx-4 text-sage" data-id="element-82">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-83">
          <path d="M12 2L15 12L22 15L15 18L12 22L9 18L2 15L9 12L12 2Z" data-id="element-84" />
        </svg>
      </div>
      <div className="w-16 md:w-24 h-[1px] bg-sage" data-id="element-85"></div>
    </div>;
}